// Works with Vite or CRA. Set VITE_API_BASE_URL or REACT_APP_API_BASE_URL if you want.
// Default points to Laravel's /api on 127.0.0.1:8000
import axios from "axios";

const base =
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_BASE_URL) ||
  process.env.REACT_APP_API_BASE_URL ||
  "https://pjgservice.com/public/api";

const api = axios.create({
  baseURL: base,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  timeout: 15000,
});

export default api;
